import script from "./Leads.vue?vue&type=script&setup=true&lang=ts"
export * from "./Leads.vue?vue&type=script&setup=true&lang=ts"

import "./Leads.vue?vue&type=style&index=0&id=f1ab0616&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1ab0616"]])

export default __exports__